import React, { useEffect, useState } from 'react';

export const SrpToolTip = ({
    tooltipText,
    tooltipDirection,
    toolTipColor
  }) => {

    return (
    <div className="tooltip__container-srp">
        <i className="perc-icon-info tooltip__info-srp"></i>
        <div className={`tooltip ${toolTipColor} ${tooltipDirection}-srp tooltip__content-srp tooltip__srp`}>
            <h4 className="tooltip__header-srp" >{tooltipText.title}</h4>
            <p dangerouslySetInnerHTML={{ __html: tooltipText.summaryHTML }} className="tooltip__body-srp" ></p>
            {tooltipText.doNotIncludeList &&
              <p className="tooltip__not-include-srp"><strong >Do not include: </strong>{tooltipText.doNotIncludeList}</p>
            }
        </div>
    </div>
    );
  }

export default SrpToolTip;